import moment from "moment";

function dateKey(date) {
  return moment(date).format("YYYY-MM-DD");
}

function weekdayKey(date) {
  return moment(date).format("ddd").toLowerCase();
}

/** Match pickup/to-go to a store by location.id, storeLocationId, then street, else default/first. */
export function resolveStoreLocation(storeLocations, fulfillment) {
  if (!storeLocations?.length) return null;

  if (fulfillment?.type && fulfillment.type !== "delivery") {
    const loc = fulfillment?.location;
    const match =
      (loc?.id && storeLocations.find((o) => o.id === loc.id)) ||
      (fulfillment?.storeLocationId &&
        storeLocations.find((o) => o.id === fulfillment.storeLocationId)) ||
      (loc?.street && storeLocations.find((o) => o.address?.street === loc.street));
    if (match) return match;
  }

  return storeLocations.find((o) => o.default) || storeLocations[0];
}

/** Weekly pickup/delivery slots for the date, overridden by special hours for that channel. */
export function getAvailableTimeslotsByDate(storeLocation, date, fulfillmentType = "pickup") {
  if (!storeLocation || !date) return [];

  const key = dateKey(date);
  const mode = fulfillmentType === "delivery" ? "delivery" : "pickup";
  let slots = storeLocation.fulfillment?.[mode]?.timeslots?.[weekdayKey(date)] || [];

  const entry = storeLocation.rules?.date?.specialHours?.[key];
  if (entry != null) {
    // Legacy entries are a flat array or pickup-only; delivery inherits pickup.
    const pickup = Array.isArray(entry) ? entry : entry.pickup;
    const override = mode === "delivery" && Array.isArray(entry.delivery) ? entry.delivery : pickup;
    if (Array.isArray(override)) slots = override;
  }

  return Array.isArray(slots) ? slots : [];
}

/** True when the store is blocked or has no open slots that day. */
export function shouldDisableStoreDate(storeLocation, date, fulfillmentType = "pickup") {
  if (!storeLocation || !date) return true;

  const key = dateKey(date);
  if ((storeLocation.rules?.date?.block || []).includes(key)) {
    return true;
  }

  const slots = getAvailableTimeslotsByDate(storeLocation, key, fulfillmentType);
  return slots.length === 0;
}
